<script>
function getParam(param){return new URLSearchParams(window.location.search).get(param)}

import idb from "./idb.js"

let files = []
let baskets = []
let recording = false

let host = ''
let hosting =_=> {
	host = prompt('Albert: Enter the password.');
	fetch("https://"+host).then(r=>idb.set('host', host)).catch(e=>{
		alert('Invalid host name. \n'+error)
		hosting()
	})
}
idb.get('host').then(r=>r?host=r:hosting()).then(_=>
	setInterval(() => fetch("https://"+host+"/recordings").then(r=>r.json()).then(r=>{
		files = r
		let folders = files.map(file => file.split("/")[4]).filter(folder => folder.length > 0)
		folders = [...new Set(folders)]
		baskets = folders.map(folder =>{ return { name: folder, items: files.filter(file => file.includes(folder)) }})
		console.log(baskets)
	}), 1000))


import { flip } from 'svelte/animate';
import { onMount } from 'svelte';

function visualize(stream) {
	if(!audioCtx) {
		audioCtx = new AudioContext();
	}

	const source = audioCtx.createMediaStreamSource(stream);

	const analyser = audioCtx.createAnalyser();
	analyser.fftSize = 2048;
	const bufferLength = analyser.frequencyBinCount;
	const dataArray = new Uint8Array(bufferLength);

	source.connect(analyser);
	//analyser.connect(audioCtx.destination);

	draw()

	function draw() {
		const WIDTH = canvas.width
		const HEIGHT = canvas.height;

		requestAnimationFrame(draw);

		analyser.getByteTimeDomainData(dataArray);

		canvasCtx.fillStyle = 'rgb(200, 200, 200)';
		canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);

		canvasCtx.lineWidth = 2;
		canvasCtx.strokeStyle = 'rgb(0, 0, 0)';

		canvasCtx.beginPath();

		let sliceWidth = WIDTH * 1.0 / bufferLength;
		let x = 0;


		for(let i = 0; i < bufferLength; i++) {

		let v = dataArray[i] / 128.0;
		let y = v * HEIGHT/2;

		if(i === 0) {
			canvasCtx.moveTo(x, y);
		} else {
			canvasCtx.lineTo(x, y);
		}

		x += sliceWidth;
		}

		canvasCtx.lineTo(canvas.width, canvas.height/2);
		canvasCtx.stroke();

	}
}


let folder = ''
let media = []
let mediaRecorder = null

let canvas
let audioCtx
let canvasCtx

onMount(async () => {

	canvasCtx = canvas.getContext("2d");
	
	const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
	visualize(stream);
	
	mediaRecorder = new MediaRecorder(stream);
	mediaRecorder.ondataavailable = (e) => media.push(e.data)
	mediaRecorder.onstop = function(){
		const blob = new Blob( media, {'type' : 'audio/mp4; codecs=aac' });
		media = [];
		const formData = new FormData();
		formData.append('audio_data', blob, folder + '-+-' + prompt('Albert: Please name the recording.'));

		fetch('/recorder', {
			method: 'POST',
			body: formData
		}).then(response => {
			console.log('Response: ', response);
		}).catch(error => {
			alert('Error: ', error);
		});
		console.log(blob)
	}
	
})

function startRecording(name){
	recording = true
	folder = name
	mediaRecorder.start()
}
function stopRecording(){
	recording = false
	mediaRecorder.stop()
}


</script>


<h1>Welcome to<br><u>Operation Vara</u></h1><br>
Please keep all limbs inside the vehicle while recording.

{#each baskets as basket}
  <div>
    <b class="name">{basket.name}</b>
	<div id="buttons">
		<button on:click={startRecording(basket.name)} class="record">Record</button>
		<button on:click={stopRecording} class="stop">Stop</button>
	</div>
    <ul class="bucket">
	{#each basket.items.sort((a, b) => !a.localeCompare(b)).filter(v=>!v.includes(".txt")) as item}
		<div class="item">
			<audio id={item.split('/').slice(-2)} 
				   src={'https://'+host+'/Recordings/'+item.split('/').slice(-2).join('/')}/>
			<li on:click={document.getElementById(item.split('/').slice(-2)).play()}>{item.split('/').slice(-1)[0]}</li>
		</div>
	{/each}
	
    </ul>
  </div>
  <br>
{/each}

<canvas bind:this={canvas} height="60px"></canvas>

<!-- <label for="toggle">❔</label> -->

<style>
	.name{
		padding:5px;
	}

	.bucket{
		background:rgba(236, 230, 230, 0.493);
	}
	.item {
		display: inline; /* required for flip to work */
		
	}
	li {
		background-color: lightgray;
		cursor: pointer;
		display: inline-block;
		margin-right: 10px;
		padding: 10px;
	}
	li:hover {
		background: orange;
		color: white;
	}
  ul {
		border: solid lightgray 1px;
		display: flex; /* required for drag & drop to work when .item display is inline */
		height: 60px; /* needed when empty */
		padding: 10px;
	}



	* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}



.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

h1, h2 {
  font-size: 2rem;
  text-align: center;
  font-weight: normal;
  padding: 0.5rem 0 0 0;
}


canvas {
	position:fixed;
	top:0;
	left:0;
	z-index:-1;
	width:100%;
	height:100%;
}

#buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

#buttons button {
  font-size: 1rem;
  padding: 1rem;
  width: calc(50% - 0.25rem);
}

button {
  font-size: 1rem;
  background: #0088cc;
  text-align: center;
  color: white;
  border: none;
  transition: all 0.2s;
  padding: 0.5rem;
}

button:hover, button:focus {
  box-shadow: inset 0px 0px 10px rgba(255, 255, 255, 1);
  background: #0ae;
}

button:active {
  box-shadow: inset 0px 0px 20px rgba(0,0,0,0.5);
  transform: translateY(2px);
}

button:focus {
  background:rgb(172, 21, 21);
  box-shadow: inset 0px 0px 20px rgba(0,0,0,0.5);
  transform: translateY(2px);
}


</style>